export default angular
  .module("DeleteModalCtrl", ["ui.bootstrap"])
  .controller("DeleteModalController", [
    "$scope",
    "$modalInstance",
    "itemToBeDeleted",
    "itemType",
    function ($scope, $modalInstance, itemToBeDeleted, itemType) {
      $scope.itemToBeDeleted = itemToBeDeleted;
      $scope.itemType = itemType;

      $scope.ok = function () {
        $modalInstance.close();
      };

      $scope.cancel = function () {
        $modalInstance.dismiss("cancel");
      };
    },
  ]);
